var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.512,
    height: 21.512,
    viewBox: "0 0 21.512 21.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-call",
    "data-name": "Icon material-call",
    d: "M8.826,13.81A18.1,18.1,0,0,0,16.7,21.685l2.629-2.629a1.188,1.188,0,0,1,1.219-.287,13.632,13.632,0,0,0,4.266.681,1.2,1.2,0,0,1,1.2,1.2v4.171a1.2,1.2,0,0,1-1.2,1.2A20.315,20.315,0,0,1,4.5,5.7,1.2,1.2,0,0,1,5.7,4.5H9.878a1.2,1.2,0,0,1,1.2,1.2,13.577,13.577,0,0,0,.681,4.266,1.2,1.2,0,0,1-.3,1.219L8.826,13.81Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#666"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.2492e7761fe0fa32229e0fe0a9893cc0.svg";
export { ForwardRef as ReactComponent };